import { InstanceEventContent } from '../../model/types/InstanceEvent'
import { EXCLUDED_FIELDS, formatFieldName, formatValue } from '../../model/lib/helpers'

export const InstanceEventsContentCell = ({ content }: {
	content: InstanceEventContent
}) => {
	const entries = Object.entries(content).filter(
		([key]) => !EXCLUDED_FIELDS.includes(key)
	)

	return (
		<ul style={{ margin: 0, paddingLeft: '1rem' }}>
			{entries.map(([key, val], idx) => (
				<li key={idx}>
					<strong>{formatFieldName(key)}</strong>
					{` - ${formatValue(val)}`}
				</li>
			))}
		</ul>
	)
}